import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, map, exhaustMap, tap, finalize } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure,
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail
} from './workflow-settings.action';
import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { HelperService } from 'src/app/core/services/helper.service';

@Injectable()
export class WorkflowSettingsRecordEffects {

    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap(() => {
                const url = 'workflow-settings';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        const data = response.data;
                        // console.log(data);
                        return fetchSingleRecordSuccess({singleData: data.record});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                                // this.routeService.triggerRoute(null, "/workflow-settings");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    updateData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateRecord),
            exhaustMap((data:any) => {
                const url = 'workflow-settings/';
                return this.crudServerService.updateDataPost(url, data.updatedData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        return updateRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => updateRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        public helperService: HelperService
    ) { }

}